var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.501,
    height: 16.346,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 217",
    d: "M14.854.848a2.468 2.468 0 00-3.491 0l-9.786 9.786a.548.548 0 00-.141.241L.149 15.521a.548.548 0 00.675.675l4.646-1.287a.548.548 0 00.241-.141l9.786-9.786a2.471 2.471 0 000-3.491zM2.772 10.99l8.009-8.009 2.583 2.583-8.009 8.009zm-.516 1.035l2.064 2.064-2.854.791zm12.466-7.819l-.582.582-2.583-2.583.582-.582a1.371 1.371 0 011.939 0l.644.644a1.373 1.373 0 010 1.94zm0 0",
    fill: "#5200f1",
    stroke: "#5200f1",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmEdit);
export default __webpack_public_path__ + "static/media/am-edit.724177ad4a27fad4b825146c506965ca.svg";
export { ForwardRef as ReactComponent };